export default "/assets/Image/manage-wallets.png"